import { render, staticRenderFns } from "./InlineNameEdit.vue?vue&type=template&id=b71216be&"
import script from "./InlineNameEdit.vue?vue&type=script&lang=ts&"
export * from "./InlineNameEdit.vue?vue&type=script&lang=ts&"
import style0 from "./InlineNameEdit.vue?vue&type=style&index=0&id=b71216be&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports